import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import MainLayout from './components/layout/MainLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import ErrorBoundary from './components/common/ErrorBoundary';
import LoadingSpinner from './components/common/LoadingSpinner';

import LoginPage from './pages/auth/LoginPage';
import SignupPage from './pages/auth/SignupPage';
import UnauthorizedPage from './pages/auth/UnauthorizedPage';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Customers = lazy(() => import('./pages/Customers'));
const RoomManagement = lazy(() => import('./pages/admin/RoomManagement'));
const CheckinPage = lazy(() => import('./pages/staff/CheckinPage'));
const ActiveSessions = lazy(() => import('./pages/staff/ActiveSessions'));
const CafeSales = lazy(() => import('./pages/staff/CafeSales'));
const CafeItems = lazy(() => import('./pages/admin/CafeItems'));
const Inventory = lazy(() => import('./pages/staff/Inventory'));
const Expenses = lazy(() => import('./pages/admin/Expenses'));
const FinanceReports = lazy(() => import('./pages/admin/FinanceReports'));
const AuditLogs = lazy(() => import('./pages/admin/AuditLogs'));

const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-900 mb-2">404</h1>
      <p className="text-gray-600">Page not found</p>
    </div>
  </div>
);

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[400px]">
    <LoadingSpinner size="lg" message="Loading..." />
  </div>
);

const App = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/register" element={<Navigate to="/signup" replace />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />

          <Route
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/rooms" element={<RoomManagement />} />
            <Route path="/checkin" element={<CheckinPage />} />
            <Route path="/active-sessions" element={<ActiveSessions />} />
            <Route path="/cafe" element={<CafeSales />} />
            <Route path="/cafe-items" element={<CafeItems />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/reports" element={<FinanceReports />} />
            <Route path="/audit-logs" element={<AuditLogs />} />
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
